import { useApp } from './AppProvider.tsx';
import type { SubEvent } from '../types/events.ts';
import { useMemo } from 'react';

const useRacesWithAwards = (): SubEvent[] => {
  const [{ event }] = useApp();
  const { subEvents } = event ?? {};
  return useMemo(
    () => (subEvents || []).filter(({ listingSettings }) => listingSettings?.hasAwards),
    [subEvents]
  );
};

export default useRacesWithAwards;
